import {BaseConfig} from "../../infrastructure/config/base-config";
import {WebsiteModuleTerms} from "./website-module.terms";
import {WebsiteModuleRemoteConfig} from "./website-module.remote-config";

export class WebsiteModuleConfig extends BaseConfig {
  lastSelectionUndoDuration: Number;

  static injectables = [WebsiteModuleTerms, WebsiteModuleRemoteConfig];

  constructor(terms: WebsiteModuleTerms, remoteConfig: WebsiteModuleRemoteConfig) {
    super('website', null, terms, remoteConfig);

    this.lastSelectionUndoDuration = 3000;
  }
}
